import { IModalProps } from "@/component/Modal";
import Modal from "@/component/Modal";
import CloseIcon from "@/assets/common/ic_close.svg";
import "./index.less";
import Login, { LoginProps } from "@/pages/Login";

export interface ILoginModal extends Pick<IModalProps, "visible" | "onClose"> {}

const LoginModal: React.FC<ILoginModal & LoginProps> = ({ visible, onClose, ...rest }) => {
  return (
    <Modal visible={visible} onClose={onClose} mask>
      <div className="login-modal bg-white px-8 py-6 rounded-2.5 shadow w-110 h-150 relative overflow-x-hidden overflow-y-auto">
        <img src={CloseIcon} className="block absolute right-2.5 top-2.5 size-6 cursor-pointer" onClick={onClose} />
        <Login {...rest} />
      </div>
    </Modal>
  );
};

export default LoginModal;
